(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-add-to-cart-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', async function (event) {
      const button = event.target.closest('.cm-add-to-cart__button');
      if (!button) return;

      button.classList.add('btn--loading');

      const productTitle = button.dataset.productName;

      let data = [
        {
          id: button.dataset.variantId,
          quantity: 1,
        },
      ];

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: data,
          }),
        });

        if (response.ok) {
          try {
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            });

            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              const itemCount = cartData.item_count;
              document.querySelector('.header-cart_item-count').textContent = itemCount;
            }
          } catch (cartError) {
            console.error('Cart Fetch Error:', cartError);
          }

          document.querySelector('.added-notification_product-title').innerHTML = productTitle;
          document.querySelector('.added-notification').classList.add('active');
          setTimeout(() => {
            document.querySelector('.added-notification').classList.remove('active');
          }, 6000);
        } else {
          console.error('Response not OK. Status Code:', response.status);
        }
      } catch (error) {
        console.error('Fetch Error:', error);
      } finally {
        button.classList.remove('btn--loading');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-collections-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    swiper = new Swiper('.cm-collections-slider__slider', {
      navigation: {
        nextEl: '.cm-collections-slider__arrows .swiper-button-next',
        prevEl: '.cm-collections-slider__arrows .swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.3,
          spaceBetween: 16,
        },
        576: {
          slidesPerView: 1.5,
          spaceBetween: 32,
        },
        991: {
          slidesPerView: 2.5,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 32,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-collections-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Tabs
    const buttons = document.querySelectorAll('.cm-tab-button');
    const tabs = document.querySelectorAll('.cm-tab-content');

    function activateTab(tabId) {
      tabs.forEach((tab) => {
        if (tab.id === tabId) {
          tab.style.display = 'block';
          requestAnimationFrame(() => {
            tab.classList.add('active');
            resetProducts(tab);
          });
        } else {
          tab.classList.remove('active');
          setTimeout(() => {
            tab.style.display = 'none';
          }, 0);
        }
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        buttons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');

        const tabId = this.getAttribute('data-tab');
        activateTab(tabId);
      });
    });

    const firstTab = document.querySelector('.cm-tab-content');
    if (firstTab) {
      firstTab.style.display = 'block';
      firstTab.classList.add('active');
      resetProducts(firstTab);
    }

    // Change variant price
    const lengthInputs = document.querySelectorAll('.variant-length__input');

    lengthInputs.forEach((input) => {
      input.addEventListener('change', function () {
        const newPrice = this.getAttribute('data-price');

        const variantCard = this.closest('.variant-card');
        if (variantCard) {
          const priceElement = variantCard.querySelector('.variant-price');
          if (priceElement) {
            priceElement.textContent = newPrice;
          }
        }
      });
    });

    // Add to Cart
    const addToCartButtons = document.querySelectorAll('.variant-card__add-to-card button');

    addToCartButtons.forEach((button) => {
      button.addEventListener('click', async function () {
        this.classList.add('btn--loading');
        const productTitle = this.dataset.productName;
        let productId =
          this.closest('.variant-card').querySelector('.variant-length input:checked')?.getAttribute('data-id') ||
          this.dataset.id;

        let data = [
          {
            id: productId,
            quantity: 1,
          },
        ];

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: data,
            }),
          });

          if (response.ok) {
            try {
              const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              if (cartResponse.ok) {
                const cartData = await cartResponse.json();
                const itemCount = cartData.item_count;
                document.querySelector('.header-cart_item-count').textContent = itemCount;
              }
            } catch (cartError) {
              console.error('Cart Fetch Error:', cartError);
            }

            document.querySelector('.added-notification_product-title').innerHTML = productTitle;
            document.querySelector('.added-notification').classList.add('active');
            setTimeout(() => {
              document.querySelector('.added-notification').classList.remove('active');
            }, 6000);
          } else {
            console.error('Response not OK. Status Code:', response.status);
          }
        } catch (error) {
          console.error('Fetch Error:', error);
        } finally {
          this.classList.remove('btn--loading');
        }
      });
    });

    function resetProducts(tabContent) {
      const productList = tabContent.querySelector('.cm-collections-tab__products-grid');
      if (!productList) return;

      const products = Array.from(productList.children);
      const initialCount = 8;
      const isMobile = window.innerWidth < 576;
      const seeMoreStep = isMobile ? 4 : 8;

      products.forEach((product, index) => {
        product.style.display = index < initialCount ? 'flex' : 'none';
      });

      let seeMoreButton = tabContent.querySelector('.see-more-button');
      if (seeMoreButton) {
        seeMoreButton.remove();
      }

      if (products.length > initialCount) {
        seeMoreButton = document.createElement('button');
        seeMoreButton.textContent = 'SEE MORE PRODUCTS';
        seeMoreButton.classList.add('see-more-button');
        tabContent.appendChild(seeMoreButton);

        let shownCount = initialCount;
        seeMoreButton.onclick = function () {
          const newLimit = shownCount + seeMoreStep;

          products.forEach((product, index) => {
            if (index < newLimit) product.style.display = 'flex';
          });

          shownCount = newLimit;
          if (shownCount >= products.length) seeMoreButton.style.display = 'none';
        };
      }
    }

    // === Tab Filters ===

    function initTabFilters(tabContent) {
      const dropdowns = tabContent.querySelectorAll('.filter-dropdown');
      const products = tabContent.querySelectorAll('.variant-card');
      const noResultText = tabContent.querySelector('.no-result__text');
      const productList = tabContent.querySelector('.cm-collections-tab__products-grid');
      const filterToggle = tabContent.querySelector('.cm-tab-filter-toggle');
      const clearAllBtn = tabContent.querySelector('.clear-all');

      // Query mobile form internals before moving the form out of the DOM tree.
      // The form must be a direct child of <body> so position:fixed resolves to
      // the viewport — ancestor animation transforms (scroll-trigger, animate--slide-in)
      // would otherwise create a new containing block and break fixed positioning.
      const filterForm = tabContent.querySelector('.cm-variant-grid__mobile-form');
      const closeFilterBtn = filterForm.querySelector('.cm-tab-filter-close');
      const filterSections = filterForm.querySelectorAll('.accordion-item');
      const footerShowButton = filterForm.querySelector('.mobile-form__footer-show');
      const footerShowSpan = filterForm.querySelector('.mobile-form__footer-show span');
      const footerClearButton = filterForm.querySelector('.mobile-form__footer-clear');
      document.body.appendChild(filterForm);

      // Desktop dropdowns
      dropdowns.forEach((dropdown) => {
        const button = dropdown.querySelector('.filter-dropdown__button');
        const svgIcon = button.querySelector('svg');

        button.addEventListener('click', function (event) {
          event.stopPropagation();

          dropdowns.forEach((d) => {
            if (d !== dropdown) {
              d.classList.remove('open');
              d.querySelector('.filter-dropdown__button').classList.remove('active');
            }
          });

          dropdown.classList.toggle('open');
          button.classList.toggle('active');
        });

        dropdown.querySelector('.filter-dropdown__content').addEventListener('click', (e) => e.stopPropagation());

        // Desktop checkbox change
        const checkboxes = dropdown.querySelectorAll('.filter-checkbox');
        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            const selectedFilters = getSelectedFilters(false);

            const selectedCheckboxes = Array.from(checkboxes).filter((cb) => cb.checked);
            button.innerHTML = '';

            if (selectedCheckboxes.length > 0) {
              const firstLabel = selectedCheckboxes[0].previousElementSibling.textContent;
              const count = selectedCheckboxes.length - 1;
              button.classList.add('selected');
              button.append(firstLabel);
              if (count > 0) {
                const countSpan = document.createElement('span');
                countSpan.classList.add('filter-count');
                countSpan.textContent = ' +' + count;
                button.appendChild(countSpan);
              }
              button.appendChild(svgIcon);
            } else {
              button.classList.remove('selected');
              button.innerHTML = 'Filter By ' + button.getAttribute('data-filter-type') + ' ';
              button.appendChild(svgIcon);
            }

            applyFilters(selectedFilters);
          });
        });
      });

      document.addEventListener('click', function () {
        dropdowns.forEach((d) => {
          d.classList.remove('open');
          d.querySelector('.filter-dropdown__button').classList.remove('active');
        });
      });

      // Mobile accordion
      filterSections.forEach((section) => {
        const header = section.querySelector('.accordion-header');
        const content = section.querySelector('.accordion-content');
        header.addEventListener('click', function () {
          if (section.classList.contains('active')) {
            content.style.maxHeight = '0';
            section.classList.remove('active');
          } else {
            filterSections.forEach((i) => {
              i.classList.remove('active');
              i.querySelector('.accordion-content').style.maxHeight = '0';
            });
            section.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 20 + 'px';
          }
        });

        section.querySelectorAll('.mobile-filter-checkbox').forEach((cb) => {
          cb.addEventListener('change', updateMobileCount);
        });
      });

      // Mobile open/close
      function openFilter() {
        document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
        const header = document.querySelector('header');
        if (header) {
          document.documentElement.style.setProperty(
            '--header-bottom-position',
            parseInt(header.getBoundingClientRect().bottom) + 'px'
          );
        }
        filterForm.classList.add('active');
        document.body.classList.add('overflow-hidden-tablet');
      }

      function closeFilterMenu() {
        filterForm.classList.remove('active');
        document.body.classList.remove('overflow-hidden-tablet');
        filterSections.forEach((section) => {
          section.classList.remove('active');
          section.querySelector('.accordion-content').style.maxHeight = '0';
        });
      }

      filterToggle && filterToggle.addEventListener('click', openFilter);
      closeFilterBtn && closeFilterBtn.addEventListener('click', closeFilterMenu);

      // Shared filter logic
      function getSelectedFilters(fromMobile) {
        const selectedFilters = {};
        const items = fromMobile
          ? filterSections
          : tabContent.querySelectorAll('.filter-dropdown');

        items.forEach((item) => {
          const typeEl = fromMobile
            ? item.querySelector('.accordion-header')
            : item.querySelector('.filter-dropdown__button');
          const type = typeEl.getAttribute('data-filter-type').toLowerCase();
          const cbSelector = fromMobile ? '.mobile-filter-checkbox:checked' : '.filter-checkbox:checked';
          const checked = Array.from(item.querySelectorAll(cbSelector));
          selectedFilters[type] = checked.map((cb) => cb.getAttribute('data-' + type));
        });

        return selectedFilters;
      }

      function applyFilters(selectedFilters) {
        let visibleCount = 0;

        products.forEach((product) => {
          const productColor = product.getAttribute('data-color') || '';
          const productCategory = product.getAttribute('data-category') || '';
          const productCollection = product.getAttribute('data-collection') || '';
          const productLengths = product.getAttribute('data-lengths') || '';
          const productCollections = productCollection.split(',').map((c) => c.trim());
          const productLengthsArray = productLengths ? productLengths.split(',').map((l) => l.trim()) : [];

          const matchesColor =
            !selectedFilters.color || selectedFilters.color.length === 0 ||
            selectedFilters.color.includes(productColor);

          const matchesCategory =
            !selectedFilters.category || selectedFilters.category.length === 0 ||
            selectedFilters.category.some((cat) => productCategory.includes(cat));

          const matchesCollection =
            !selectedFilters.collection || selectedFilters.collection.length === 0 ||
            selectedFilters.collection.some((col) => productCollections.includes(col));

          const matchesLength =
            !selectedFilters.length || selectedFilters.length.length === 0 ||
            selectedFilters.length.some((len) => productLengthsArray.includes(len));

          if (matchesColor && matchesCategory && matchesCollection && matchesLength) {
            product.style.display = 'flex';
            visibleCount++;
          } else {
            product.style.display = 'none';
          }
        });

        if (productList) productList.style.display = visibleCount === 0 ? 'none' : 'grid';
        if (noResultText) noResultText.classList.toggle('active', visibleCount === 0);

        return visibleCount;
      }

      function updateMobileCount() {
        filterSections.forEach((section) => {
          const checkboxes = section.querySelectorAll('.mobile-filter-checkbox');
          const headerSpan = section.querySelector('.accordion-header span');
          const activeCount = Array.from(checkboxes).filter((cb) => cb.checked).length;
          headerSpan.textContent = activeCount > 0 ? '' + activeCount : '';
        });

        const selectedFilters = getSelectedFilters(true);
        const hasAny = Object.values(selectedFilters).some((arr) => arr.length > 0);

        if (!footerShowSpan) return;

        if (!hasAny) {
          footerShowSpan.textContent = '';
          return;
        }

        let count = 0;
        products.forEach((product) => {
          const productColor = product.getAttribute('data-color') || '';
          const productCategory = product.getAttribute('data-category') || '';
          const productCollection = product.getAttribute('data-collection') || '';
          const productLengths = product.getAttribute('data-lengths') || '';
          const productCollections = productCollection.split(',').map((c) => c.trim());
          const productLengthsArray = productLengths ? productLengths.split(',').map((l) => l.trim()) : [];

          const matchesColor = !selectedFilters.color.length || selectedFilters.color.includes(productColor);
          const matchesCategory = !selectedFilters.category.length || selectedFilters.category.some((cat) => productCategory.includes(cat));
          const matchesCollection = !selectedFilters.collection.length || selectedFilters.collection.some((col) => productCollections.includes(col));
          const matchesLength = !selectedFilters.length.length || selectedFilters.length.some((len) => productLengthsArray.includes(len));

          if (matchesColor && matchesCategory && matchesCollection && matchesLength) count++;
        });

        footerShowSpan.textContent = '(' + count + ')';
      }

      function updateMobileToggleCount() {
        if (!filterToggle) return;
        let activeFilters = 0;
        filterSections.forEach((section) => {
          activeFilters += section.querySelectorAll('.mobile-filter-checkbox:checked').length;
        });
        let countSpan = filterToggle.querySelector('.filter-count');
        if (activeFilters > 0) {
          if (!countSpan) {
            countSpan = document.createElement('span');
            countSpan.classList.add('filter-count');
            filterToggle.appendChild(countSpan);
            filterToggle.classList.add('active');
          }
          countSpan.textContent = ' ' + activeFilters;
        } else if (countSpan) {
          countSpan.remove();
          filterToggle.classList.remove('active');
        }
      }

      footerShowButton && footerShowButton.addEventListener('click', () => {
        const selectedFilters = getSelectedFilters(true);
        applyFilters(selectedFilters);
        updateMobileToggleCount();
        closeFilterMenu();
      });

      footerClearButton && footerClearButton.addEventListener('click', () => {
        filterSections.forEach((section) => {
          section.querySelectorAll('.accordion-header span').forEach((s) => { s.textContent = ''; });
          section.querySelectorAll('.mobile-filter-checkbox').forEach((cb) => { cb.checked = false; });
        });
        if (footerShowSpan) footerShowSpan.textContent = '';
        products.forEach((p) => { p.style.display = 'flex'; });
        if (productList) productList.style.display = 'grid';
        if (noResultText) noResultText.classList.remove('active');
        updateMobileToggleCount();
        closeFilterMenu();
      });

      clearAllBtn && clearAllBtn.addEventListener('click', () => {
        dropdowns.forEach((dropdown) => {
          const button = dropdown.querySelector('.filter-dropdown__button');
          const svgIcon = button.querySelector('svg');
          button.classList.remove('selected');
          button.innerHTML = 'Filter By ' + button.getAttribute('data-filter-type') + ' ';
          button.appendChild(svgIcon);
          dropdown.querySelectorAll('.filter-checkbox').forEach((cb) => { cb.checked = false; });
        });
        products.forEach((p) => { p.style.display = 'flex'; });
        if (productList) productList.style.display = 'grid';
        if (noResultText) noResultText.classList.remove('active');
      });
    }

    document.querySelectorAll('.cm-tab-content').forEach(initTabFilters);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-colors-in-stock-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    //tabs
    const buttons = document.querySelectorAll('.cm-colors-in-stock-slider__tabs-buttons button');
    const contents = document.querySelectorAll('.cm-colors-in-stock-slider__tabs-content');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        buttons.forEach((btn) => btn.classList.remove('active'));
        contents.forEach((content) => content.classList.remove('active'));

        this.classList.add('active');
        document.getElementById(this.dataset.tab).classList.add('active');
      });
    });

    //swipers
    document.querySelectorAll('.cm-colors-in-stock-slider__tabs-content').forEach((tab, index) => {
      new Swiper(`.cm-colors-in-stock-slider__swiper-${index}`, {
        slidesPerView: 3.7,
        spaceBetween: 32,
        navigation: {
          nextEl: '.cm-colors-in-stock-slider__arrows .swiper-button-next',
          prevEl: '.cm-colors-in-stock-slider__arrows .swiper-button-prev',
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 32,
          },
          480: {
            slidesPerView: 1.3,
            spaceBetween: 32,
          },
          650: {
            slidesPerView: 2.3,
          },
          991: {
            slidesPerView: 2.7,
          },
          1200: {
            slidesPerView: 3.7,
          },
        },
      });
    });

    //add to cart
    const addToCartButtons = document.querySelectorAll('.variant-card__add-to-card button');

    addToCartButtons.forEach((button) => {
      button.addEventListener('click', async function () {
        this.classList.add('btn--loading');
        const productTitle = this.dataset.productName;
        let productId =
          this.closest('.variant-card').querySelector('.variant-length input:checked')?.getAttribute('data-id') ||
          this.dataset.id;

        let data = [
          {
            id: productId,
            quantity: 1,
          },
        ];

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: data,
            }),
          });

          if (response.ok) {
            try {
              const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              if (cartResponse.ok) {
                const cartData = await cartResponse.json();
                const itemCount = cartData.item_count;
                document.querySelector('.header-cart_item-count').textContent = itemCount;
              }
            } catch (cartError) {
              console.error('Cart Fetch Error:', cartError);
            }

            document.querySelector('.added-notification_product-title').innerHTML = productTitle;
            document.querySelector('.added-notification').classList.add('active');
            setTimeout(() => {
              document.querySelector('.added-notification').classList.remove('active');
            }, 6000);
          } else {
            console.error('Response not OK. Status Code:', response.status);
          }
        } catch (error) {
          console.error('Fetch Error:', error);
        } finally {
          this.classList.remove('btn--loading');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-slider-shop-by-method"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const sliderContainer = document.querySelector('.cm-slider-shop-by-method__slider');
  if (!sliderContainer) return;

  const slides = sliderContainer.querySelectorAll('.swiper-slide');

  const updateSliderClass = () => {
    if (window.innerWidth >= 1200) {
      if (slides.length <= 4) {
        sliderContainer.classList.add('no-slide');
      } else {
        sliderContainer.classList.remove('no-slide');
      }
    } else {
      sliderContainer.classList.remove('no-slide');
    }
  };

  const swiper = new Swiper(sliderContainer, {
    navigation: {
      nextEl: '.cm-slider-shop-by-method__arrows .swiper-button-next',
      prevEl: '.cm-slider-shop-by-method__arrows .swiper-button-prev',
    },
    breakpoints: {
             320: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        576: {
          slidesPerView: 2.2,
          spaceBetween: 32,
        },
        991: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 4.2,
          spaceBetween: 32,
        },
    },
    on: {
      init: updateSliderClass,
      resize: updateSliderClass,
    },
  });

  window.addEventListener('resize', updateSliderClass);
  updateSliderClass();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-slider-with-double-photo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    swiper = new Swiper('.cm-slider-with-double-photo__slider', {
      spaceBetween: 24,
      navigation: {
        nextEl: '.cm-slider-with-double-photo__arrows .swiper-button-next',
        prevEl: '.cm-slider-with-double-photo__arrows .swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          slidesOffsetBefore: 16,
        },
        480: {
          slidesPerView: 1.5,
          slidesOffsetBefore: 0,
        },
        1024: {
          slidesPerView: 2.3,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let swiper = null;

    const initSwiper = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth <= 768) {
        if (!swiper) {
          swiper = new Swiper('.cm-video-testimonials-slider', {
            spaceBetween: 32,
            navigation: {
              nextEl: '.cm-video-testimonials-slider__arrows .swiper-button-next',
              prevEl: '.cm-video-testimonials-slider__arrows .swiper-button-prev',
            },
            breakpoints: {
              320: {
                slidesPerView: 1.2,
                slidesOffsetBefore: 16,
              },
              576: {
                slidesPerView: 2,
                slidesOffsetBefore: 0,
              },
            },
          });
        }
      } else {
        if (swiper && typeof swiper.destroy === 'function') {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    if (document.querySelector('.cm-video-testimonials-slider')) {
      initSwiper();

      window.addEventListener('resize', initSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let swiper = null;

    const initSwiper = () => {
      if (!swiper) {
        swiper = new Swiper('.image-slider-swiper', {
          spaceBetween: 32,
          pagination: {
            el: '.image-slider-swiper__dots .swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 1.2,
              slidesOffsetBefore: 16,
            },
            576: {
              slidesPerView: 2,
              slidesOffsetBefore: 0,
            },
            768: {
              slidesPerView: 3.2,
              slidesOffsetBefore: 0,
            },
          },
        });
      }
    };

    if (document.querySelector('.image-slider-swiper')) {
      initSwiper();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
